import React, { Component } from "react"
import I18n from "../utils/i18n.js"
import _ from 'underscore'

import Gite from './models/gite'
import BNB from './models/bnb'
import Sale from './models/sale'
import UpdateCSSTransitionGroup from '../utils/update_css_transition_group'
import createReactClass from 'create-react-class'

export default createReactClass({
  getInitialState () {
    return {
      screenSize: 'loading'
    };
  },

  componentDidMount() {

    this.onResizeCb = () => {
      this.onResize();
    }

    window.addEventListener('resize', this.onResizeCb)

    this.onResizeCb();
    return this.updatePricesAndRatingsForAccommodations();
  },

  componentDidUnMount() {
    window.removeEventListener('resize', this.onResizeCb)
  },

  onResize() {
    let state = {
      screenSize: ''
    }
    if ($(window).outerWidth() < 767) {
      state.screenSize = 'mobile'
    } else {
      state.screenSize = 'desktop'
    }
    this.setState(state)
  },

  componentDidUpdate(prevProps, prevState) {
    const accommodations_eq = _.isEqual(this.props.accommodations, prevProps.accommodations);

    if (!accommodations_eq) { return this.updatePricesAndRatingsForAccommodations(); }
  },

  updatePricesAndRatingsForAccommodationsPath() {
    switch(I18n.locale) {
      case 'nl':
        return '/vakantiehuizen/prices_and_ratings'
      case 'en':
        return '/en/for-rent/prices_and_ratings'
      case 'de':
        return '/de/zu-mieten/prices_and_ratings'
      case 'fr':
        return '/fr/a-louer/prices_and_ratings'
    }
  },
  updatePricesAndRatingsForAccommodations() {
    if (this.prices_request) {
      this.prices_request.abort()
    }

    this.prices_request = $.ajax({
      url: this.updatePricesAndRatingsForAccommodationsPath(),
      dataType: 'json',
      data: {
        ids: _.map(this.props.accommodations, ac => ac.id)
      },
      success: (data => {
        return this.setState({prices: data.prices, ratings: data.ratings});
      })
    });
  },

  getAccommodationIds() {
    return _.map(this.props.accommodations, ac => ac.id);
  },

  getPriceFor(accommodation) {
    return this.state.prices[accommodation.id];
  },

  getRatingFor(accommodation) {
    return this.state.ratings[accommodation.id];
  },

  accommodationHover(accommodation){
    if (this.props.onAccommodationChange != null) { return this.props.onAccommodationChange(accommodation); }
  },

  getInitialState() {
    return {
      prices: {},
      ratings: {}
    };
  },

  getDefaultProps() {
    return {
      accommodations: [],
      total: 0,
      favoriting: false
    };
  },

  render() {
    const self = this;
    const accommodations_classes = `overview__accommodations${this.props.isUpdating ? ' overview__accommodations--updating' : ' overview__accommodations--done'}`;
    let accommodations = this.props.accommodations.map(function(accommodation) {
      const price = self.getPriceFor(accommodation);
      const rating = self.getRatingFor(accommodation);
      const result = (() => { switch (accommodation.type) {
        case 'gites':
          return <Gite
            screenSize={self.state.screenSize}
            favoriting={self.props.favoriting}
            accommodation={accommodation}
            price={price}
            rating={rating}
            favoriteToggled={self.props.favoriteToggled}
          />;
        case 'bed_and_breakfasts':
          return <BNB
          screenSize={self.state.screenSize}
          favoriting={self.props.favoriting}
          accommodation={accommodation}
          price={price}
          rating={rating}
          favoriteToggled={self.props.favoriteToggled}
        />;
        case 'sales':
          return <Sale
          screenSize={self.state.screenSize}
          favoriting={self.props.favoriting}
          accommodation={accommodation}
          price={price}
          favoriteToggled={self.props.favoriteToggled}
        />;
      } })();

      return <article onMouseEnter={self.accommodationHover.bind(self, accommodation)} className="accommodation" onMouseLeave={self.accommodationHover.bind(self, null)} key={accommodation.id}>
        {result}
      </article>;
    });

    if ((accommodations.length === 0) && (this.props.total === 0)) { accommodations = <p>{I18n.t('search.no_results')}</p>; }

    return <div className={accommodations_classes}>
      <UpdateCSSTransitionGroup
        is_updating={this.props.isUpdating}
        enter_class='accommodation-enter'
      >{accommodations}</UpdateCSSTransitionGroup>
    </div>;
  }
});
